import { useCallback, useEffect, useState } from 'react';
import { API } from '../../api';

// El panel proxea las rutas de sólo lectura de TalentSenseAI: es de consulta,
// no de configuración (el spec con el que se clasifica se elige por corrida en
// Label). Cada recurso se pide por separado y guarda su propio error: el
// servicio puede tener los YAML bien y no poder consultar la facturación, y en
// ese caso las otras pestañas tienen que seguir sirviendo.
const emptyResource = { data: null, loading: true, error: null };

export default function useAIAdminData() {
    const [specs, setSpecs] = useState(emptyResource);
    const [models, setModels] = useState(emptyResource);
    const [account, setAccount] = useState(emptyResource);
    // Cada bump vuelve a pedir todo; los saldos además saltean el caché del
    // backend, que es lo que el usuario espera al apretar "Actualizar".
    const [reloadCount, setReloadCount] = useState(0);

    useEffect(() => {
        const controller = new AbortController();
        const load = (url, setter) => {
            setter((prev) => ({ ...prev, loading: true }));
            API.get(url, { signal: controller.signal })
                .then(({ data }) => setter({ data, loading: false, error: null }))
                .catch((e) => {
                    if (e?.name === 'AbortError') return;
                    setter({ data: null, loading: false, error: e?.response?.data?.detail ?? true });
                });
        };

        load('/ai/specs/', setSpecs);
        load('/ai/models/', setModels);
        load(reloadCount > 0 ? '/ai/account/?refresh=1' : '/ai/account/', setAccount);

        return () => controller.abort();
    }, [reloadCount]);

    const reload = useCallback(() => setReloadCount((n) => n + 1), []);

    return { specs, models, account, reload };
}
